import { Col, Input, Row } from 'antd'
import cx from 'classnames'
import _ from 'lodash'
import pluralize from 'pluralize'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import validator from 'validator'
import { KDMStatuses, UserRoles } from '../../common/enums'

import { frameTheatreAddress } from '../../common/util/helper'
import DownloadKDMIcon from '../../icons/download-kdm.svg'
import EmailIcon from '../../icons/email.svg'
import LoaderIcon from '../../icons/loading.svg'
import KDMTableContentItem from './KDMTableContentItem'
import { DEVICE_MANAGER_ROLE } from '../../common/config'

class KDMInfo extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      sendKDMEmail: '',
      sendKDMEmailError: '',
      sendEmail: false,
      sendKDMEmailSuccess: ''
    }
  }

  getBasicInfo () {
    return (
      <Row>
        <p
          className="composition-name-label qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold">{I18n.t('compositions.name')}</p>
        <p
          className="composition-name qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal">{this.props.composition.name}</p>
      </Row>
    )
  }

  getKDMTableHeader () {
    return (
      <Row
        className="kdm-table-header qw-bold qw-mt-x-small qw-border-bottom qw-font-size-small qw-py-x-small qw-color-text-secondary-heading qw-font-weight-bold qw-line-height-small">
        <Col span={8} className='qw-px-x-small'>{I18n.t('compositions.screen')}</Col>
        <Col span={7} className='qw-px-x-small'>{I18n.t('compositions.status')}</Col>
        <Col span={9} className='qw-px-x-small'>{I18n.t('compositions.validity')}</Col>
      </Row>
    )
  }

  getKDMTableContent () {
    const {composition, theatre} = this.props
    return (
      <div className="kdm-table-content-wrapper overflow-scroll">
        <KDMTableContentItem theatre={theatre} composition={composition}/>
      </div>
    )
  }

  getTheatreInfo () {
    const {theatre} = this.props
    const totalScreenCount = !_.isEmpty(theatre.screens) ? theatre.screens.length : 0
    const kdmScreenCount = !_.isEmpty(theatre.screens) ? theatre.screens.filter(
      s => s.isKdmIssued).length : 0
    return (
      <div>
        <p
          className="qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold">{I18n.t('theatre.theatre')}</p>
        <p
          className="qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal">{theatre.name}</p>
        <p
          className="qw-font-size-xx-small qw-line-height-xx-small">{frameTheatreAddress(theatre)}</p>
        <p
          className="qw-font-size-xx-small qw-line-height-xx-small">{`${kdmScreenCount}/${totalScreenCount} ${pluralize(I18n.t('compositions.screens'), totalScreenCount)}`}</p>
      </div>
    )
  }

  getKDMDeliveryEmail () {
    const {theatre: {kdmDeliveryMethods}} = this.props
    const kdmDeliveryEmail = kdmDeliveryMethods &&
      kdmDeliveryMethods.filter(method => method.type === 'Email')
        .map(method => method.email)
        .join(', ')
    return (
      <div>
        <p
          className="qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold">{I18n.t('compositions.kdmDeliveryEmail')}</p>
        <p
          className="qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal">{_.isEmpty(kdmDeliveryEmail)
          ? I18n.t('general.none')
          : kdmDeliveryEmail}</p>
      </div>
    )
  }

  validateSendEmail () {
    const {sendKDMEmail} = this.state
    if (_.isEmpty(sendKDMEmail.replace(/ /g, ''))) {
      this.setState({sendKDMEmailError: I18n.t('compositions.sendKDMEmailError.empty')})
      return false
    }

    const emails = sendKDMEmail.replace(/ /g, '').split(',')
    const invalidEmails = emails.filter(email => !validator.isEmail(email))
    if (invalidEmails.length) {
      this.setState({sendKDMEmailError: `${I18n.t('compositions.sendKDMEmailError.invalidEmail')} - ${invalidEmails.join(', ')} `})
      return false
    }
    return true
  }

  sendKDMEmail () {
    this.setState({
      sendKDMEmailError: '',
      sendKDMEmailSuccess: ''
    })

    if (this.validateSendEmail()) {
      this.setState({sendEmail: true})

      let payload = {}
      let {composition: {name: compositionName, id: compositionId}, theatre} = this.props
      payload.facility_id = theatre.id
      payload.composition_names = [compositionName]
      payload.earliest_kdm_validity = _.minBy(theatre.kdms, 'validFrom').validFrom
      payload.latest_kdm_validity = _.minBy(theatre.kdms, 'validTill').validTill
      payload.kdms = {}
      payload.email_addresses = {to: this.state.sendKDMEmail.replace(/ /g, '').split(',')}

      this.props.sendKDMEmail([compositionId], [theatre.id], payload, (status) => {
        this.setState({
          sendEmail: false,
          sendKDMEmailError: !status ? I18n.t('compositions.sendKDMEmailError.send') : '',
          sendKDMEmailSuccess: status ? I18n.t('compositions.sendKDMEmailSuccess') : ''
        })
      })
    }
  }

  onChangeSendKDMEmail (e) {
    this.setState({
      sendKDMEmail: e.target.value,
      sendKDMEmailError: '',
      sendKDMEmailSuccess: ''
    })
  }

  hideKDMEmail (kdmGenerationCompleted, theatre, user) {
    return (user.info.role_in_product.code === DEVICE_MANAGER_ROLE) ||
      (!kdmGenerationCompleted || !theatre.kdms.find(kdm => [
        KDMStatuses.success,
        KDMStatuses.generated
      ].includes(kdm.status.type.toLowerCase())))
  }

  render () {
    const {kdmGenerationCompleted, theatre, downloadKDMS, user} = this.props
    const {sendEmail, sendKDMEmail, sendKDMEmailSuccess, sendKDMEmailError} = this.state
    return (
      <div className="kdm-info">
        <Row>
          <Col span={8}>{this.getTheatreInfo()}</Col>
          <Col span={16}>{this.getBasicInfo()}</Col>
        </Row>
        <Row className="qw-mt-small">
          <Col span={24}>{this.getKDMDeliveryEmail()}</Col>
        </Row>
        <Row
          className={cx('qw-mt-small', {'qw-display-none': this.hideKDMEmail(kdmGenerationCompleted, theatre, user)})}>
          <Col span={16}>
            <Row>
              <Col span={20}>
                <Row>
                  <Col span={20}>
                    <Input
                      className={cx({'qw-border-error': !_.isEmpty(sendKDMEmailError)})}
                      value={sendKDMEmail} placeholder={I18n.t('compositions.enterEmailAddress')}
                      onChange={(e) => this.onChangeSendKDMEmail(e)}
                    />
                    <p
                      className="qw-font-size-xx-small qw-line-height-xx-small qw-color-text-red qw-mt-xx-small">{sendKDMEmailError}</p>
                    <p
                      className="qw-font-size-xx-small qw-line-height-xx-small qw-color-text-green qw-mt-xx-small">{sendKDMEmailSuccess}</p>
                  </Col>
                  <Col span={4} onClick={() => this.sendKDMEmail()}
                       className="qw-cursor-pointer qw-flex qw-align-middle qw-justify-center">
                    {sendEmail ? <LoaderIcon className="qw-icon-medium"/> :
                      <span>
                        <EmailIcon
                          className="qw-icon-medium inline qw-align-middle qw-mr-xx-small"/>
                        <p
                          className="email inline-block qw-font-size-small qw-line-height-small qw-mt-xx-small">{I18n.t('compositions.email')}</p>
                      </span>}
                  </Col>
                </Row>
              </Col>
              <Col span={4}>
                <Row
                  className="download-summary-wrap qw-cursor-pointer qw-flex qw-align-middle qw-justify-center">
                <span onClick={() => downloadKDMS()}>
                  <Col span={9}><DownloadKDMIcon className="qw-icon-medium"/></Col>
                  <Col span={15}><p
                    className="download-summary qw-pt-xx-small qw-align-middle qw-font-size-small qw-line-height-small">{I18n.t('compositions.download')}</p></Col>
                  </span>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <div>
          {this.getKDMTableHeader()}
          {this.getKDMTableContent()}
        </div>
      </div>
    )
  }
}

export default KDMInfo



// WEBPACK FOOTER //
// ./src/app/components/compositions/KDMInfo.js